import { DateCell } from '@shared/components/data-table/cells/date-cell';
import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import { ColumnDef } from '@tanstack/react-table';

export function useGetTransportColumns(): ColumnDef<any>[] {
  return [
    {
      accessorKey: 'uuid',
    },
    {
      id: 'name',
      accessorKey: 'name',
      enableColumnFilter: true,
      enableHiding: false,
      header: ({ column }) => (
        <HeaderCell column={column} name="Transport step" />
      ),
      cell: ({ getValue }) => {
        const name = getValue<string>();
        return <p className="min-w-[150px] max-w-[240px] truncate">{name}</p>;
      },
      meta: {
        label: 'Search',
        variant: 'text',
        sorting: { ascLabel: 'A-Z', descLabel: 'Z-A' },
      },
    },
    {
      accessorKey: 'createdDate',
      header: ({ column }) => (
        <HeaderCell column={column} name="Creation date" />
      ),
      cell: ({ getValue }) => {
        const date = getValue<string>();
        return (date && <DateCell date={date} />) ?? null;
      },
      enableSorting: true,
    },
  ];
}
